import SwitchEcoBillFake from "./switch";
import PillWithIconFake from "@/components/Fakes/pill-with-icon-fake";
import styles from "./styles";

const EcoBillFake = ({ withouContainer }) => {
  return (
    <>
    <div className={withouContainer ? "" : "container"}>
      <div className="ecobill__fake">
        <div className="ecobill__fake--box">
          <div className="skeleton ecobill__fake--box--title" />
          <SwitchEcoBillFake />
        </div>
        <div className="skeleton ecobill__fake--text" />
        <PillWithIconFake />
        <PillWithIconFake />
      </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default EcoBillFake;
